<template lang="pug">
  .wrap
    .close(@click="makeChoice" title="Schließen")
      font-awesome-icon(:icon="['fa', 'times']")
    .inner-wrap
      h2 Wo möchten Sie zuerst hin?
      .block-wrap
        .block(@click="makeChoice")
          router-link(:to="'/'")
            img(v-if="webpSupport" src="~@/assets/img/start01.webp", width="340", height="230", alt="Restaurant Ercklentz")
            img(v-else src="~@/assets/img/start01.jpg", width="340", height="230", alt="Restaurant Ercklentz")
            .link-block
              h3 Restaurant Ercklentz
              .desc Judenstraße 8 I 47906 Kempen
        .block(@click="makeChoice")
          router-link(:to="'/private-cooking'")
            img(v-if="webpSupport" src="~@/assets/img/start02.webp", width="340", height="230", alt="Private Cooking")
            img(v-else src="~@/assets/img/start02.jpg", width="340", height="230", alt="Private Cooking")
            .link-block
              h3 Private Cooking
              .desc Wir kochen bei Ihnen zuhause
        .block(@click="makeChoice")
          router-link(:to="'/lieferservice'")
            img(v-if="webpSupport" src="~@/assets/img/start03.webp", width="340", height="230", alt="Lieferleckerservice")
            img(v-else src="~@/assets/img/start03.jpg", width="340", height="230", alt="Lieferleckerservice")
            .link-block
              h3 Lieferleckerservice
              .desc Unsere Speisekarte
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
    name: 'Welcome',
    computed: {
        ...mapGetters({
            webpSupport: 'webpSupport'
        })
    },
    mounted () {
      document.body.classList.add('welcome-screen')
    },
    destroyed () {
      document.body.classList.remove('welcome-screen')
    },
    methods: {
      makeChoice() {
        this.setFirstVisit(false);
      },
      ...mapMutations({
            setFirstVisit: 'setFirstVisit'
      })
    }
};
</script>
<style lang="sass" scoped>
  @import "~@/assets/sass/variables"
  .wrap
    @apply absolute w-full h-full z-30 hidden
    background-color: rgba(#fff, 0.95)
    @screen md
      @apply block
    .close
      @apply absolute text-2xl cursor-pointer 
      right: 20px
      top: 10px
      opacity: 0
      animation: fadeIn 2s forwards
      animation-delay: 1s
      &:hover
        color: $color-primary
    .inner-wrap
      @apply flex flex-col justify-center items-center w-full h-full
      h2
        @apply text-3xl font-bold mb-6
      .block-wrap
        @apply flex flex-wrap justify-center
        animation: fadeIn 2s
        .block
          @apply px-4
          min-width: 200px
          &:hover
            .link-block
              background-color: $color-primary
          .link-block
            @apply my-4 mx-6 p-2 text-center bg-white shadow-lg transition-all duration-300 ease-in-out
            h3
              @apply text-lg font-bold uppercase
          img
            @apply shadow-md
  
  @keyframes fadeIn
    0%
      opacity: 0
    100%
      opacity: 1

</style>
